

// //toast
// import toast from '@/components/Toast';

//bind_Modal
//大区绑定
import bind_modal from '@/components/AreaBind';

//story_modal
import story_modal from '@/components/StoryModal';

// copy_Modal
import copy_modal from '@/components/CopyModal';

// record_Modal
import record_modal from '@/components/RecordModal';

//invite_modal
import invite_apply from '@/components/InviteApply';

//invite_modal
import invite_team_apply from '@/components/InviteApplyTeam';

//team_agree_modal
import team_agree from '@/components/TeamApply';

// msg_Modal
import msg_modal from '@/components/MsgModal';

//comfirm_modal
import comfirm_modal from '@/components/ComfirmModal';

let utils = {
    // $toast: toast,
    $bind_modal : bind_modal,
    $story_modal : story_modal,
    $copy_modal : copy_modal,
    $record_modal : record_modal,
    $invite_apply : invite_apply,
    $team_agree : team_agree,
    $msg_modal : msg_modal, 
    $invite_team_apply : invite_team_apply,
    $comfirm_modal : comfirm_modal,  
}

export default utils;